import { useState } from 'react';

import { LoginFields } from '@playbooks/components/auth/login-fields';
import { MfaChallengeForm } from '@playbooks/components/auth/mfa-challenge-form';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { AuthBrand } from 'components/auth/auth-brand';
import { AuthDivider } from 'components/auth/auth-divider';
import { AuthFormShell } from 'components/auth/auth-form-shell';
import { AuthProviderActions } from 'components/auth/auth-provider-actions';
import { useStore } from 'contexts';
import { useAction } from 'hooks';

const LoginForm = ({ onBack, onNext, onView }) => {
	const [user, setUser] = useState<any>({});
	const [challenge, setChallenge] = useState<any>(null);
	const store = useStore();

	// Hooks
	const [onSave, saveTask] = useAction(async () => {
		const response = await store.createRecord({ url: '/auth/login', data: user });
		await onAuth(response.data);
	});

	// Methods
	const onAuth = async data => {
		if (data?.status === 'mfa_required') return setChallenge(data);
		await onNext(data);
	};

	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};

	// Render
	if (challenge)
		return (
			<AuthFormShell as='section'>
				<MfaChallengeForm challenge={challenge} onNext={onNext} onCancel={() => setChallenge(null)} allowRecovery />
			</AuthFormShell>
		);

	return (
		<AuthFormShell onSubmit={onSubmit} className='space-y-5'>
			<Button type='button' variant='outline' size='icon-xs' aria-label='Back to sign-in options' onClick={onBack}>
				<Icon type='far' icon='chevron-left' aria-hidden />
			</Button>
			<AuthBrand title='Log in' description='Welcome back' />
			<div className='flex-column gap-4'>
				<LoginFields user={user} setUser={setUser} />
				<Button type='submit' size='lg' isLoading={saveTask.running} className='w-full'>
					Log in
				</Button>
			</div>
			<AuthDivider>or continue with</AuthDivider>
			<AuthProviderActions compact onNext={onAuth} />
			<p className='text-center text-xs text-foreground-subtle'>
				New to Playbooks?{' '}
				<Link
					variant='link'
					href='/auth?view=register'
					onClick={e => (e.preventDefault(), onView('register'))}
					className='inline h-auto p-0 text-action'>
					Register
				</Link>
			</p>
		</AuthFormShell>
	);
};

export { LoginForm };
